import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useTranslation } from "react-i18next";
import { ConversationItem } from "src/components/GlobalChatbot/ConversationItem";
import { groupConversationsByDate } from "src/components/GlobalChatbot/groupConversationsByDate";
import { useChatbotConversations } from "src/hooks/useChatbotConversations";

// ponytail: stała liczba ostatnich rozmów; pełna lista z wyszukiwarką jest pod "Zobacz wszystkie"
const RECENT_LIMIT = 10;

interface ChatbotHistoryPopoverProps {
	activeConversationId: string | null;
	onSelect: (conversationId: string) => void;
	onSeeAll: () => void;
	onClose: () => void;
}

export const ChatbotHistoryPopover = ({
	activeConversationId,
	onSelect,
	onSeeAll,
	onClose,
}: ChatbotHistoryPopoverProps) => {
	const { t } = useTranslation();
	const { data: conversations = [] } = useChatbotConversations();
	const groups = groupConversationsByDate(
		conversations.slice(0, RECENT_LIMIT),
		t,
	);

	return (
		<ClickAwayListener onClickAway={onClose}>
			<div
				className="popper chatbot-history-popover"
				data-test-id="global-chatbot-history-popover"
			>
				<div className="chatbot-history-popover-header">
					<span className="size-16">
						{t("globalChatbot.history.popoverTitle", "Historia konwersacji")}
					</span>
					<button
						type="button"
						className="chatbot-history-popover-see-all text-primary-link size-14"
						data-test-id="global-chatbot-history-see-all"
						onClick={onSeeAll}
					>
						{t("globalChatbot.history.seeAll", "Zobacz wszystkie")}
					</button>
				</div>

				<div className="chatbot-history-popover-list scroll">
					{groups.map((group) => (
						<div key={group.label}>
							<div className="chatbot-history-group-label">{group.label}</div>
							{group.items.map((conversation) => (
								<ConversationItem
									key={conversation.id}
									conversation={conversation}
									selected={conversation.id === activeConversationId}
									onSelect={onSelect}
									timeInline
									className="chatbot-history-item--plain"
									testId="global-chatbot-history-popover-item"
								/>
							))}
						</div>
					))}

					{groups.length === 0 && (
						<div className="text-center text-grey size-12-light p-24">
							{t("globalChatbot.history.empty", "Brak rozmów")}
						</div>
					)}
				</div>
			</div>
		</ClickAwayListener>
	);
};
